<template>
  <v-card>
    <app-header></app-header>
    <div :class="isLogin ? 'mt-70' : ''"></div>
    <v-container grid-list-xl>
      <v-layout row wrap justify-center>
        <v-flex xs12 md7 lg10 class="col-height-auto">
          <div>
            <h1 class="fw-700 mb-5 text-center">SiP Content Policy</h1>
            <div class="font-16 mb-4 fw-400">
              SiP is a platform for communities to discuss, connect, and share in an open environment, home to some of the most authentic content anywhere online. The
              nature of this content might be funny, serious, offensive, or anywhere in between. While participating, it’s important to keep in mind this value above
              all others: show enough respect to others so that we all may continue to enjoy SiP for what it is.
            </div>
            <h3 class="mb-4 fw-700">Unwelcome content</h3>
            <div class="font-16 mb-3 fw-400">
              While SiP generally provides a lot of leeway in what content is acceptable, here are some guidelines for content that is not. Please keep in mind the
              spirit in which these were written, and know that looking for loopholes is a waste of time.
            </div>
            <div class="font-16 mb-3 fw-400">
              Content is prohibited if it
              <ul class="mt-3 ml-3">
                <li>Is illegal</li>
                <li>
                  Is involuntary pornography
                  <ul class="mt-2 ml-3">
                    <li class="mb-1">
                      SiP prohibits the dissemination of images or video depicting any person in a state of nudity or engaged in any act of sexual conduct
                      apparently created or posted without their permission, including depictions that have been faked.
                    </li>
                    <li>
                      Images or video of intimate parts of a person’s body, even if the person is clothed or in public, are also not allowed if apparently
                      created or posted without their permission and contextualized in a salacious manner (e.g., “creepshots” or “upskirt” imagery).
                      Additionally, do not post images or video of another person for the specific purpose of faking explicit content or soliciting
                      “lookalike” pornography.
                    </li>
                  </ul>
                </li>
                <li class="mt-2">
                  Is sexual or suggestive content involving minors
                  <ul class="mt-2 ml-3">
                    <li>
                      This includes child sexual abuse imagery, child pornography, and any other content, including fantasy content (e.g. stories,
                      “loli”/anime cartoons), that depicts encourages or promotes pedophilia, child sexual exploitation, or otherwise sexualizes minors or
                      someone who appears to be a minor. Depending on the context, this can in some cases include depictions of minors that are fully clothed
                      and not engaged in overtly sexual acts.
                      If you are unsure about a piece of content involving a minor or someone who appears to be a minor, do not post it.
                    </li>
                  </ul>
                </li>
                <li class="mt-2">
                  Encourages or incites violence
                  <ul class="mt-2 ml-3">
                    <li>
                      Do not post content that encourages, glorifies, incites, or calls for violence or physical harm against an individual or a group of
                      people; likewise, do not post content that glorifies or encourages the abuse of animals. We understand there are sometimes reasons to
                      post violent content (e.g., educational, newsworthy, artistic, satire, documentary, etc.) so if you’re going to post something violent
                      in nature that does not violate these terms, ensure you provide context to the viewer so the reason for posting is clear. If your
                      content is borderline, please use a NSFW tag. Even mild violence can be difficult for someone to explain to others if they open it
                      unexpectedly
                    </li>
                  </ul>
                </li>
                <li class="mt-2">
                  Threatens, harasses, or bullies or encourages others to do so
                  <ul class="mt-2 ml-3">
                    <li>We do not tolerate the harassment of people on our site, nor do we tolerate communities dedicated to fostering harassing behavior. Harassment on SiP is defined as systematic and/or continued actions to torment or demean someone in a way that would make a reasonable person conclude that SiP is not a safe platform to express their ideas or participate in the conversation, or fear for their safety or the safety of those around them. Being annoying, vote brigading, or participating in a heated argument is not harassment, but following an individual or group of users, online or off, to the point where they no longer feel that it's safe to post online or are in fear of their real life safety is.</li>
                  </ul>
                </li>
                <li class="mt-2">
                  Is personal and confidential information
                  <ul
                    class="mt-2 ml-3"
                  >It is not okay to post someone's personal information or post links to personal information. This includes links to public Facebook pages and screenshots of Facebook pages with the names still legible. Posting someone's personal information will get you banned. When posting screenshots, be sure to edit out any personally identifiable information to avoid running afoul of this rule. Public figures can be an exception to this rule, such as posting professional links to contact a congressman or the CEO of a company. But don't post anything inviting harassment, don't harass, and don't cheer on or upvote obvious vigilantism.</ul>
                </li>
                <li class="mt-2">
                  Impersonates someone in a misleading or deceptive manner
                  <ul class="mt-2 ml-3">
                    <li>SiP does not allow users to impersonate someone in a misleading or deceptive manner. However, we do permit satire and parody accounts and subSIPs pertaining to public figures. If you believe someone is impersonating you in contravention of these guidelines, please contact the admins and we will review the account.</li>
                  </ul>
                </li>
                <li class="mt-2">
                  Uses SIP to solicit or facilitate any transaction or gift involving certain goods and services
                  <ul class="mt-2 ml-3">
                    <li>
                      Content is prohibited if it uses SiP to solicit or facilitate any transaction or gift involving certain goods and services. You may not use SiP to solicit or facilitate any transaction or gift involving certain goods and services, including
                      <ul>
                        <li>Firearms, ammunition, bump-stock-type devices, explosives, or 3D printing files to produce firearms or bump-stock-type devices;</li>
                        <li>Drugs, including alcohol and tobacco, or any controlled substances;</li>
                        <li>Paid services involving physical sexual contact;</li>
                        <li>Stolen goods;</li>
                        <li>Personal information;</li>
                        <li>Falsified official documents or currency;</li>
                        <li>Fraudulent services;</li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="mt-2">
                  Is spam
                  <ul class="mt-2 ml-3">
                    <li>Spam on SiP is generally defined as repeated, unwanted, and/or unsolicited actions, whether automated or manual, that negatively affect SiP users, SiP communities, and/or SiP itself. Spam is punishable by content removal and account suspension or termination. As spam-like behaviors evolve, SiP will continue to adjust how we mitigate and prevent the spread of spam content.</li>
                  </ul>
                </li>
                <li class="mt-2">
                  <span
                    class="fw-700"
                  >The following are examples of behavior that may be considered spam and are subject to removal/suspension:</span>
                  <ul class="mt-2 ml-3">
                    <li>Sending large amounts of private messages to users who are not expecting them.</li>
                    <li>Repeatedly posting the same or similar comments.</li>
                    <li>Repeatedly posting unrelated/off-topic/link-farmed content.</li>
                    <li>Posting content that includes link redirects as a way to circumvent an existing domain block and/or to disguise a link’s source.</li>
                    <li>Linking to harmful third-party content, such as malware, phishing, deceptive pop-ups, etc.</li>
                    <li>Programming bots that harm/break SiP, including bots intended to promote content/products/services.</li>
                  </ul>
                </li>
              </ul>
              <h3 class="mb-4 mt-4 fw-700">Prohibited behavior</h3>
              <div class="mb-3">
                In addition to not submitting unwelcome content, the following behaviors are prohibited on SiP
                <ul class="mt-2 ml-3">
                  <li class="mt-2">
                    Asking for votes or engaging in vote manipulation
                    <ul class="mt-2 ml-3">
                      <li>Vote manipulation is against the SiP rules, whether it is manual, programmatic, or otherwise. Some common forms of vote cheating are:</li>
                    </ul>
                  </li>
                  <li
                    class="mt-2"
                  >Using multiple accounts, voting services, or any other software to increase or decrease vote scores.</li>
                  <li>Asking people to vote up or down certain posts, either on SiP itself or through social networks, messaging, etc. for personal gain.</li>
                  <li>Forming or joining a group that votes together, either on a specific post, a user's posts, posts from a domain, etc.</li>
                  <li>
                    Breaking SiP or doing anything that interferes with the normal use of SiP
                    <ul class="mt-2 ml-3">
                      <li>Don't break the site or do anything that interferes with normal use of the site. Do not interrupt the serving of SiP, introduce malicious code onto SiP, make it difficult for anyone else to use SiP due to your actions, block sponsored headlines, create programs that violate any of our other API rules, or assist anyone in misusing SiP in any way.</li>
                    </ul>
                  </li>
                  <li
                    class="mt-2"
                  >Creating multiple accounts to evade punishment or avoid restrictions</li>
                </ul>
              </div>
              <h3 class="mb-4 mt-4 fw-700">NSFW (Not Safe For Work) content</h3>
              <div
                class="mb-4"
              >Content that contains nudity, pornography, or profanity, which a reasonable viewer may not want to be seen accessing in a public or formal setting such as in a workplace should be tagged as NSFW. This tag can be applied to individual pieces of content or to entire communities.</div>
              <h3 class="mb-4 mt-4 fw-700">Enforcement</h3>
              <div class="font-16 mb-3 fw-400">
                We have a variety of ways of enforcing our rules, including, but not limited to
                <ul class="mt-2 ml-3">
                  <li>Asking you nicely to knock it off.</li>
                  <li>Asking you less nicely.</li>
                  <li>Temporary or permanent suspension of accounts.</li>
                  <li>Removal of privileges from, or adding restrictions to, accounts.</li>
                  <li>Removal of content.</li>
                </ul>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Vue from "vue";
import config from "../../config.js";
export default {
  data() {
    return {};
  },
  computed: {},
  computed: {
    isLogin() {
      if (
        this.$store.state.user.token != null &&
        this.$store.state.user.token != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {},
  mounted: function() {},
  watch: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// ContentPolicy.vue?a91d7896